import { Button, styled } from "@mui/material";
import { useEffect } from "react";
import { UseFormSetValue, FieldPath } from "react-hook-form";
import { useKeyPress } from "../../../../../hooks/useKeyPress";
import colors from "../../../../../theme/themeConstants";
import SelectDate from "../../../SelectDate";
import { ISignUpFieldValues } from "../AuthSignUp";

interface IProps {
  next: () => void;
  setValue: UseFormSetValue<ISignUpFieldValues>;
}

const SignUpBirthStep = (props: IProps) => {
  const { next, setValue } = props;

  const handleBirth = (value: number) => {
    setValue<FieldPath<ISignUpFieldValues>>("birthday", value);
  };
  const enterPressed = useKeyPress("Enter");

  useEffect(() => {
    if (enterPressed) {
      next();
    }
    // eslint-disable-next-line
  }, [enterPressed])

  return (
    <Container>
      <SelectDate onChange={handleBirth}/>
      <Button variant="contained" fullWidth sx={{
        background: colors.purpleGradient,
        margin: "2rem 0 0rem 0",
        minHeight: "3rem",
        borderRadius: "38px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        }
      }} onClick={next}>
        <span>Next</span>
      </Button>
    </Container>
  );
};

export default SignUpBirthStep;

const Container = styled("div")({
});
